'use strict';
import React from 'react';
import flux from 'utils/flux';
import { Navigation } from 'react-router';
import Immutable from 'immutable';

var HeaderBarLicensing = React.createClass({
    displayName: 'HeaderBarLicensing',
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },
    mixins: [
        Navigation
    ],
    _getSelectedItems() {
        return this.props.basket.get('items').filter((item) => {
            return item.get('_requestLicense') === true;
        });
    },

    toggleCheckAll() {
        flux.getActions('basket').toggleLicensingAll();
    },

    requestLicensing() {
        var selected = this._getSelectedItems();
        var requests = selected.map((item) => {
            return {
                id: item.get('id'),
                comment: item.get('_usageText') ? item.get('_usageText') : ''
            };
        }).toJS();

        flux.getStore('basket').requestLicensing( this.props.basket.get('id'), requests ).then( () => {
            this.transitionTo( 'singleLicensing', { id: this.props.basket.get('id') }, { success: true });
        });
    },

    render() {
        var selected = Immutable.List();
        var allSelected = Immutable.List();

        if (this.props.basket.size !== 0) {
            selected = this._getSelectedItems();
            allSelected = this.props.basket.get('items').size === selected.size;
        }

        if (this.props.basket.size === 0 || this.props.basket.get('items').size === 0) {
            return false;
        }


        return (
            <div className="headerbar--licensing">
                <div className="headerbar__selection">
                    <form className="all__checkbox">
                        <div className="field__checkbox field__checkbox--small">
                            <input id="check__all" checked={allSelected} type="checkbox" readOnly />
                            <label onClick={this.toggleCheckAll} htmlFor="check__all">{flux.t('select_all')}</label>
                        </div>
                    </form>
                    <span className="all__count">
                        {flux.getStore('translations').getFormattedMessage('selected_items', {count: selected.size})}
                    </span>
                </div>
                <div className="headerbar__actions">
                    <button disabled={selected.size === 0} onClick={this.requestLicensing} className="btn btn-border">
                        {flux.t('request_licensing')}
                    </button>
                </div>
            </div>
        );
    }
});

module.exports = HeaderBarLicensing;



// WEBPACK FOOTER //
// ./app/components/headerBar/headerLicensing.jsx